import React from 'react';
import { Reveal } from './Reveal';
import { frameworkItems } from '../data/framework';
export function FrameworkSection() {
  return <section className="bg-brand-cream px-4 py-16 md:py-24" data-id="element-86" data-mp="3gc295inwo9fj">
      <Reveal className="mx-auto max-w-[1120px]" data-id="element-87" data-mp="32dcbo1x6c7qn">
        <div className="mx-auto mb-10 max-w-2xl text-center md:mb-12" data-id="element-88" data-mp="32ckmp9y3189c">
          <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-89" data-mp="37am7q0f2jhng">INSIDE EVERY VOLUME</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-90" data-mp="2slgect2wwlnh">
            More Than Activities — A Complete Teaching Framework
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-91" data-mp="2jne3zmxaggnj">
          {frameworkItems.map(({
          icon: ItemIcon,
          title,
          description
        }) => <article key={title} className="rounded-2xl border border-brand-dark bg-brand-alt p-7 text-center" data-id="element-92" data-mp="2ojbh7kd996w3">
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-blue/[0.06] text-brand-blue" data-id="element-93" data-mp="2en8iyplixsef">
                <ItemIcon className="h-6 w-6" strokeWidth={1.6} aria-hidden="true" data-id="element-94" data-mp="xq7f8zxay529" />
              </span>
              <h3 className="mt-5 text-xl font-bold text-brand-blue" data-id="element-95" data-mp="squinngmpjmh">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-96" data-mp="16s6vvr4en74o">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}